const toggleEventsTable = (e) => {
  const tableWrapper = e.target.nextElementSibling;
  const arrow = e.target.querySelector('.right-angle');

  if (tableWrapper && arrow) {
    if (tableWrapper.style.maxHeight) {
      tableWrapper.style.maxHeight = null;
      arrow.style.transform = 'rotate(0deg)';
    } else {
      tableWrapper.style.maxHeight = `${tableWrapper.scrollHeight}px`;
      arrow.style.transform = 'rotate(270deg)';
    }
  }
};

export default toggleEventsTable;
